import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import PaymentCard from './PaymentCard'


const PaymentAccount = (props, {formatMessage}) => (
    <div className={cn("payment", "payment--flex", "payment--theme-default", "payment--responsive")}>
        <div className={cn([
            "payment__col",
            "payment__col__gutter"
        ])}>
            <div className={cn([
                "payment__title",
                "payment__title--indent",
                "text-center",
            ])}>{formatMessage("Account type")}</div>
            <div className={cn([
                "payment__block",
                "payment__block--flex",
            ])}>
                <div className={cn([
                    "payment__subtitle",
                    "payment__subtitle--indent",
                    "text-center",
                ])}>{formatMessage("Premium")}</div>
                <div className={cn([
                    "payment__icon",
                    "payment__icon-premium",
                    "payment__icon--indent",
                ])}></div>
                <div className={cn([
                    "payment__text",
                    "text-center",
                ])}>{formatMessage("Premium account is valid until")}</div>
                <div className={cn([
                    "payment__text",
                    "payment__text-lg",
                    "payment__text-bold",
                    "text-center",
                ])}>17.01.2019</div>
            </div>
        </div>
        <div className={cn([
            "payment__col",
            "payment__col__gutter"
        ])}>
            <div className={cn([
                "payment__title",
                "payment__title--indent",
                "text-center",
            ])}>{formatMessage("Pay premium")}</div>
            <PaymentCard />
            <button type="button" className={cn([
                "payment__button",
                "payment__button--block",
            ])}>{formatMessage("Pay annual premium")}</button>
        </div>
    </div>
)
PaymentAccount.contextTypes = {formatMessage: PropTypes.any}

export default PaymentAccount


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Payment/PaymentAccount.js